import { Button } from '@chakra-ui/react';

interface IDispatchProps {
  closeFiltersPanel: () => void;
  clearAllFilters: () => void;
  onSubmit?: () => void;
  onSubmitLabel?: string;
  hasClearAllFilters?: boolean;
  hasCancelButton?: boolean;
  isValid?: boolean;
}

export const Footer = (props: IDispatchProps): JSX.Element => {
  const {
    clearAllFilters,
    closeFiltersPanel,
    onSubmit,
    onSubmitLabel,
    hasClearAllFilters = true,
    hasCancelButton = false,
    isValid = true,
  } = props;

  return (
    <>
      {hasCancelButton && (
        <Button variant="secondary" onClick={closeFiltersPanel} mr="4">
          Cancel
        </Button>
      )}
      {hasClearAllFilters && (
        <Button variant="secondary" onClick={clearAllFilters} mr="auto">
          Clear all filters
        </Button>
      )}
      <Button
        data-selector={`${onSubmitLabel ? 'submit' : 'close'}-button`}
        isDisabled={!isValid}
        variant="solid"
        onClick={() => {
          if (onSubmit) onSubmit();
          closeFiltersPanel();
        }}
      >
        {onSubmitLabel || 'Close'}
      </Button>
    </>
  );
};
